<!-- 
Mfa Second factor verification during sign-in process.
Users need to verify their verification code using their second factor enrolment.
-->
<template>
  <v-container>
    <v-layout>
      <v-flex 
        xs12 
        sm10 offset-sm1 
        md8 offset-md2 
        lg6 offset-lg3
        xl4 offset-xl4
      >
        <div class="text-xs-center mb-3 pt-4">
          <img src="@/assets/aus-govt-logo-centered.png" alt="Australian Government" height="150px">
        </div>
        <h1 class="text-xs-center display-1 mb-3 mt-2">Levies Tuition Protection Service {{ environment }}</h1>
        <mfa-attempt-challenge-panel />
        <disclaimer-copyright-and-privacy-links />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import MfaAttemptChallengePanel from "@/components/users/MfaAttemptChallengePanel.vue";
import DisclaimerCopyrightAndPrivacyLinks from "@/components/system/DisclaimerCopyrightAndPrivacyLinks.vue";

export default {
  name: "MfaSignInAttempt",
  components: { MfaAttemptChallengePanel, DisclaimerCopyrightAndPrivacyLinks },
  computed: {
    environment() {
      return this.$store.getters.environmentForToolbar;
    }
  }
};
</script>
